import { Component, AfterViewInit, OnInit } from '@angular/core';
// import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AuthenticationService } from '../../authentication/authentication.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { NavigationTrackerService } from '../service/navigation-tracker.service';
import { Theme } from '../service/AutoTheme';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { SampleDataComponent } from '../sample-data/sample-data.component';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingService } from '../../setting/setting.service';
import * as moment from 'moment-timezone';
import { Subscription, interval } from 'rxjs';
import { ProfileService } from '../../profile/profile.service';
import { AutopaymentService } from '../service/autopayment.service';
import { AddamountComponent } from '../addamount/addamount.component';
import { TicketComponent } from '../../support/ticket/ticket.component';
declare var $: any;

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})


export class NavigationComponent implements OnInit {

  private timeSubscription: Subscription;
  public currentTime: Date = new Date();

  name: string;
  showHide: boolean;
  public admin: any;
  public config: PerfectScrollbarConfigInterface = {};
  sampledata: boolean = false;
  navigationDataArr: any = []
  unsubscribe: any;
  x = 0
  secondaryArr: any = [];
  usertype: any = 0;
  getServerTime: any = [];
  balance: any;
  public card_data: any;
  autoPaymentBalance: any;
  constructor(private active: ActivatedRoute, private Auth: AuthenticationService, private datePipe: DatePipe, public theme: Theme, protected router: Router, public routerChangeService: NavigationTrackerService, public dialog: MatDialog, private timeZoneService: SettingService, private formBuilder: FormBuilder, protected data1: ProfileService, public data: AutopaymentService) {
    this.showHide = true;
    const keyobj: any = this.decryptData(sessionStorage.getItem('tokenauthkey'));
    console.log(keyobj);
    this.usertype = keyobj.type

    // this.ngForm = this.formBuilder.group({
    //   timezone: ['']
    // });
    // this.tzNames = moment.tz.names();
    // this.timeZoneChanged(this.usertimezone);
    // this.updateTime(this.selectedTz);
    // setInterval(() => {
    //   this.updateTime(this.selectedTz);
    // }, 1000);

  }

  // This is for Notifications
  notifications: Object[] = [{
    round: 'round-danger',
    icon: 'ti-link',
    title: 'Luanch Admin',
    subject: 'Just see the my new admin!',
    time: '9:30 AM'
  }, {
    round: 'round-success',
    icon: 'ti-calendar',
    title: 'Event today',
    subject: 'Just a reminder that you have event',
    time: '9:10 AM'
  }, {
    round: 'round-info',
    icon: 'ti-settings',
    title: 'Settings',
    subject: 'You can customize this template as you want',
    time: '9:08 AM'
  }, {
    round: 'round-primary',
    icon: 'ti-user',
    title: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:00 AM'
  }];

  // This is for Mymessages
  mymessages: Object[] = [{
    useravatar: 'assets/images/users/1.jpg',
    status: 'online',
    from: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:30 AM'
  }, {
    useravatar: 'assets/images/users/2.jpg',
    status: 'busy',
    from: 'Sonu Nigam',
    subject: 'I have sung a song! See you at',
    time: '9:10 AM'
  }, {
    useravatar: 'assets/images/users/2.jpg',
    status: 'away',
    from: 'Arijit Sinh',
    subject: 'I am a singer!',
    time: '9:08 AM'
  }, {
    useravatar: 'assets/images/users/4.jpg',
    status: 'offline',
    from: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:00 AM'
  }];
  ngOnDestroy() {
    this.timeSubscription.unsubscribe();
  }
  ngOnInit() {
    // this.getservertime()


    this.data1.getService('cards').subscribe((res: any) => {
      console.log("card data ::", res);
      this.card_data = res.find((element) => element.isdefault === 1);
    })

    this.theme.balanceData.subscribe((res: any) => {
      console.log("getting responce after add balance in account :::", res);
      this.balance = res;
    })

    this.balance = sessionStorage.getItem('balance')

    this.timeSubscription = interval(1000).subscribe(() => {
      this.currentTime = new Date();
    });


    sessionStorage.setItem('isClosingTab', 'true')
    if (sessionStorage.getItem("dummy") == "1" || sessionStorage.getItem("sample_data") == "1") {
      this.sampledata = true
    }
    var navigationData = {}
    if (sessionStorage.getItem('start_time') == '' || sessionStorage.getItem('start_time') == null || sessionStorage.getItem('start_time') == undefined) {
      navigationData = { event: { url: '', id: 0 } }
      navigationData['type'] = "IN"
      navigationData['event']['url'] = this.active.snapshot['_routerState'].url
      console.log(this.active.snapshot['_routerState'].url)
      navigationData['start_time'] = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss')
      navigationData['end_time'] = ''
      navigationData['duration'] = ''
      sessionStorage.setItem('event', this.active.snapshot['_routerState'].url)
      sessionStorage.setItem('start_time', this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'))
      this.navigationDataArr.push(navigationData)





      this.Auth.saveNavigation(this.navigationDataArr).subscribe(res => {
        console.log(res)
        let navigationData2 = { ...navigationData }
        navigationData2['type'] = "OUT"
        this.navigationDataArr = []
        this.secondaryArr.push(navigationData2)
        this.listenForRouteChanges(navigationData)
      })
    } else {
      this.secondaryArr = []
      this.navigationDataArr = []
      navigationData = { event: { url: '', id: 0 } }
      navigationData['type'] = sessionStorage.getItem('navigation_type')
      navigationData['event']['url'] = sessionStorage.getItem('event')
      console.log(this.active.snapshot['_routerState'].url)
      navigationData['start_time'] = sessionStorage.getItem('start_time')
      navigationData['end_time'] = ''
      navigationData['duration'] = ''
      // this.navigationDataArr.push(navigationData)
      this.secondaryArr.push(navigationData)
      this.listenForRouteChanges(navigationData)
    }
    // this.Auth.saveNavigation(this.navigationDataArr)
    this.theme.sample_Data.subscribe((res: any) => {
      console.log(res)
      if (sessionStorage.getItem("dummy") == "1") {
        this.sampledata = true
      }
    })

  }

  // onRefresh(){

  //   this.Auth.saveNavigation(this.navigationDataArr).subscribe(res=>{
  //     sessionStorage.removeItem('event')
  //     sessionStorage.removeItem('start_time')
  //     console.log(res)
  //   })

  // }
  /**
   * Decrypt method for decode authkey
   */
  decryptData(data): void {
    try {
      const bytes = CryptoJS.AES.decrypt(data, sessionStorage.getItem('token'));
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.error(e);
    }
  }

  dummyData(event) {
    // this.theme.dummyDatas(event.checked)

  }
  public listenForRouteChanges(data) {
    let navigationData = data
    console.log(navigationData['event'] == undefined)



    // this.Auth.saveNavigation(this.navigationDataArr).subscribe(res=>{
    //   console.log(res)
    //   this.navigationDataArr=[]
    // })

    this.unsubscribe = this.router.events.subscribe(event => {

      // console.log(event)
      if (event instanceof NavigationEnd) {
        console.log(event);

        console.log(this.navigationDataArr)
        // navigationData.event=event
        // if(this.navigationDataArr.length==0){
        // console.log('Route changed:', event);
        //   navigationData['event']=event
        //   navigationData['start_time']=this.datePipe.transform(new Date(),'yyyy-MM-dd HH:mm:ss' )
        //   navigationData['end_time']=''
        //   navigationData['duration']=''
        //   this.navigationDataArr.push(navigationData)
        //   this.Auth.saveNavigation(this.navigationDataArr).subscribe(res=>{
        //     console.log(res)
        //     // this.navigationDataArr=[]
        //   })
        // this.Auth.saveNavigation(this.navigationDataArr)
        // }else{
        navigationData['type'] = sessionStorage.getItem('navigation_type') ? sessionStorage.getItem('navigation_type') : "OUT"
        this.navigationDataArr.push(navigationData)
        let navigationData1 = {}
        navigationData1['event'] = event
        navigationData1['start_time'] = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss')
        navigationData1['end_time'] = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss')
        navigationData1['duration'] = ''
        navigationData1['type'] = 'IN'
        sessionStorage.setItem('event', event.url)
        sessionStorage.setItem('navigation_type', 'OUT')
        sessionStorage.setItem('start_time', this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'))
        this.navigationDataArr.push(navigationData1)
        //  sessionStorage.removeItem('event')
        //  sessionStorage.removeItem('start_time')
        this.Auth.saveNavigation(this.navigationDataArr).subscribe(res => {
          console.log(res)
          this.navigationDataArr = []
          navigationData = navigationData1
          let navigationData2 = { ...navigationData1 }
          navigationData2['type'] = "OUT"
          this.secondaryArr = []
          this.secondaryArr.push(navigationData2)
          //   this.navigationDataArr=[]
          //   console.log('Route changed:', event);
          //   navigationData['event']=event
          //   navigationData['start_time']=this.datePipe.transform(new Date(),'yyyy-MM-dd HH:mm:ss' )
          //   navigationData['end_time']=''
          //   navigationData['duration']=''
          //   navigationData['type']='OUT'

          // this.navigationDataArr[this.navigationDataArr.length-1].end_time= navigationData['start_time']

          // this.navigationDataArr[this.navigationDataArr.length-1].duration=this.timeDiff( this.navigationDataArr[this.navigationDataArr.length-1]['start_time'],navigationData['start_time'])
          // this.navigationDataArr.push(navigationData)
          //   this.navigationDataArr.push(navigationData)
          //   console.log("fsdgdfbg",this.navigationDataArr)
          //   console.log("fsdgdfbg",this.navigationDataArr)
        })
        // this.Auth.saveNavigation(this.navigationDataArr)
        // }
        console.log("fsdgdfbg", this.navigationDataArr)
        // this.Auth.saveNavigation(this.navigationDataArr).subscribe(res=>{
        //   console.log(res)
        //   this.navigationDataArr=[]
        // })
        // add your custom code here
      }
    });
    this.getAmount();

  }
  public timeDiff(start_time, end_time) {
    const duration = (new Date(end_time)).getTime() - (new Date(start_time)).getTime();
    console.log(duration, "duration");

    const hours = Math.floor(duration / 3600000);
    const minutes = Math.floor((duration - (hours * 3600000)) / 60000);
    const seconds = Math.floor((duration - (hours * 3600000) - (minutes * 60000)) / 1000);
    const durationString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    console.log(durationString);
    return durationString
  }
  /**
   * To signout the current user
   */
  userLogout(): void {
    console.log("navigationArr", this.navigationDataArr)
    // this.routerChangeService.appmod='navigation'
    this.unsubscribe.unsubscribe()

    this.Auth.saveNavigation(this.secondaryArr).subscribe(res => {

      console.log(res)
      // this.routerChangeService.navigationDataArr=[]
    })
    this.Auth.custumerStatus({ status: 'logout', last_login_id: sessionStorage.getItem('Last_l_id') }).subscribe(res => {
      console.log(res)
    })

    if (sessionStorage.getItem('soo_login') == '1') {
      this.Auth.customerlogout().subscribe(res => {
        localStorage.clear();
        sessionStorage.clear();
        this.Auth.redirectToPanel();
      })
    }
    else
      this.Auth.logout();

  }
  removeSample() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '500px';
    dialogConfig.data = "true"
    const dialogRef = this.dialog.open(SampleDataComponent, dialogConfig)
    dialogRef.afterClosed().subscribe(res => {
      console.log(res)
      if (res == false) {
        this.Auth.remove_Sample().subscribe((res: any) => {
          console.log(res);
          if (res.status == 200) {
            this.sampledata = false
            sessionStorage.removeItem("sample_data")
            sessionStorage.removeItem("dummy")
            location.reload()
          }
        })

      }
    })
  }

  getservertime() {
    this.timeZoneService.getservertime().subscribe(res => {
      this.getServerTime = res.records;
      console.log('res', res.records)
    })
  }

  getCard(val?: number) {
    this.data1.getService('cards').subscribe((res: any) => {
      console.log("card data ::", res);
      this.card_data = res.find((element) => element.isdefault === 1);
      if (!res.err) {
        if (val) {
          if (res.length > 0) {
            const dialogRef = this.dialog.open(AddamountComponent, {
              width: '400px',
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result != null || result != undefined) {
                // this.addamount(result);
              }
            })
          } else {
            this.router.navigate(['/main/billing/billing'])
          }
        }
      }
    }, err => {
      console.log("getting error");
      this.router.navigate(['/main/billing/billing'])
    })
  }

  getBalance() {
    this.data.getbalance().subscribe((res: any) => {
      if (!res.error) {
        this.autoPaymentBalance = res[0].balance;
      }
    }, err => {
      this.autoPaymentBalance = 0;
      console.error("err::", err)
    })
  }
  opendialog(val: number): void {
    this.getCard(val)
  }
  getAmount() {
    this.data1.getService('sumbalance').subscribe((res: any) => {
      const balance = parseInt(res[0].balance);
      const balance1 = parseInt(sessionStorage.getItem('balance'));
      if (balance + 100 > balance1) {
        let netamount = parseInt(res[0].balance) + 100;
        sessionStorage.setItem('balance', netamount.toString());
        this.balance = sessionStorage.getItem('balance');
      } else {
        console.log("not comming here :::");

      }
    });
  }
}